import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: '[fadeInAnimation]',
	animations: [
		trigger('fadeIn', [
			// the "in" style determines the "resting" state of the element when it is visible.
			state('in', style({ opacity: 1 })),

			// fade in when created. this could also be written as transition('void => *')
			transition(':enter', [
				style({ opacity: 0 }),
				animate(800)
			]),

			// fade out when destroyed. this could also be written as transition('void => *')
			transition(':leave',
				animate(800, style({ opacity: 0 })))
		])
	],
	template: `<ng-content></ng-content>`
})
export class FadeInAnimationComponent {
	@HostBinding('@fadeIn') public trigger = '';
}
